module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-BLUE.f0987117.png";